export const getIsUserLeftProjectPage = (projectId?: string) => {
  const location = window.location.pathname.split('/').pop();

  return location !== projectId;
};
